var path = '/templates/projects.campaigns/show_notes.html';
var html = "<h4>{{ 'projectsCampaigns.notes.title' | translate }}</h4><section><zc-campaign-note note=all mode=list campaign=campaign></zc-campaign-note></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.campaigns/show_notes.html
// module id = 1400
// module chunks = 0